import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaymentGroup } from '../../../../../models/entities/payment-group';
import { PaymentDetailDialogComponent, PaymentDetailDialogInput } from '../../../shared/payment-detail-dialog/payment-detail-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { LegFiJwtService } from '../../../../../services/auth/legfi-jwt.service';
import { JwtLegFiClaims } from '../../../../../services/auth/jwt-legfi-claims.model';
import { PaymentGroupsService } from '../../../../../services/payment/payment-groups.service';
import { GrowlerService } from '../../../../../services/growler.service';
import { GenericDialogResult } from '../../../shared/generic-mat-dialog/generic-dialog-result';
import { ArchiveService } from '../../../../../services/archive.service';
import { ConfirmActionDialogComponent, ConfirmActionDialogInput } from '../../../shared/confirm-action-dialog/confirm-action-dialog.component';
import { ValidationMessageService } from '../../../../../services/validation-message.service';
import { ConfirmWithInputDialogComponent, ConfirmWithInputDialogInput, ConfirmWithInputDialogResult } from '../../../shared/confirm-with-input-dialog/confirm-with-input-dialog.component';
import { DeleteOfflinePaymentDialogComponent, DeleteOfflinePaymentDialogInput, DeleteOfflinePaymentDialogResult } from 'app/components/app-layout/shared/delete-offline-payment-dialog/delete-offline-payment-dialog.component';

@Component({
    selector: 'app-multi-payment-actions',
    templateUrl: './multi-payment-actions.component.html',
})
export class MultiPaymentActionsComponent implements OnInit
{
    @Input() payments: PaymentGroup[] = [];
    @Input() itemsOnly = false;
    @Output() reload: EventEmitter<void> = new EventEmitter<void>();
    @Output() exportCsv: EventEmitter<void> = new EventEmitter<void>();

    jwt: JwtLegFiClaims;
    hasWriteAccess = false;

    constructor(
            private _archive: ArchiveService,
            private _dialog: MatDialog,
            private _growler: GrowlerService,
    ) {
    }

    ngOnInit(): void {
        this.jwt = LegFiJwtService.read();
        this.hasWriteAccess = LegFiJwtService.doesUserHaveModulePermission(
                'payments',
                true,
        );
    }

    showPaymentDetail(id: number) {
        this._dialog.open(PaymentDetailDialogComponent, {
            data: <PaymentDetailDialogInput>{
                paymentGroupId: id,
            },
        });
    }

    deleteOfflinePaymentGroups() {
        const data: DeleteOfflinePaymentDialogInput = {
            paymentGroups: this.payments,
        };
        this._dialog.open(DeleteOfflinePaymentDialogComponent, {
            data: data,
        }).afterClosed().subscribe((result: DeleteOfflinePaymentDialogResult) => {
            if (result.success) {
                this.reload.emit();
            }
        });
    }

    archivePayments() {
        this._dialog.open(ConfirmActionDialogComponent, {
            data: <ConfirmActionDialogInput>{
                title: 'Archive Payments?',
                content: `Are you sure you wish to archive the (${this.payments.length}) selected payments? Archived payments will no longer appear anywhere and cannot be restored.`,
                confirmButton: 'Yes, archive payments',
            },
        }).afterClosed().subscribe((result: GenericDialogResult) => {
            if (result?.success) {
                this._archive.archiveRecords(null, 'paymentGroup', this.payments.map(pg => pg.id)).subscribe(
                        () => {
                            this.reload.emit();
                        },
                        () => {
                            this._growler.error('Error Archiving Payments', `Failed to archive some payments`);
                        },
                );
            }
        });
    }
}
